import React from "react";
import {Route, Switch} from "react-router-dom";
import CompanyCrewPlanning from "./crew/CompanyCrewPlanning";
import CompanyCrewCrewMembers from "./crew/CompanyCrewCrewMembers";
import {
    selectCompany,
    selectCompanyRegistration
} from "../../redux/preferences/selectors";
import {selectUser} from "../../redux/auth/selectors";
import {connect} from "react-redux";
import {defaultCrewProps} from "../../libs/utils";

class _Crew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            registration: undefined
        };
    }

    static propTypes = {
        ...defaultCrewProps
    };

    render() {
        const {user, userCompany, registration} = this.props;

        return [
            <Switch key="switch">
                <Route
                    path="/crew/planning"
                    render={routeProps => (
                        <CompanyCrewPlanning
                            {...routeProps}
                            user={user}
                            userCompany={userCompany}
                            userEvent={registration.event}
                            registration={registration}
                        />
                    )}
                />

                <Route
                    path="/crew/crewmembers"
                    exact
                    render={routeProps => (
                        <CompanyCrewCrewMembers
                            {...routeProps}
                            user={user}
                            userCompany={userCompany}
                            userEvent={registration.event}
                            registration={registration}
                        />
                    )}
                />

                <Route
                    path="/crew/crewmembers/:id/edit"
                    exact
                    render={routeProps => (
                        <CompanyCrewCrewMembers
                            {...routeProps}
                            user={user}
                            userCompany={userCompany}
                            userEvent={registration.event}
                            registration={registration}
                        />
                    )}
                />
            </Switch>
        ];
    }
}

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = function (state) {
    return {
        user: selectUser(state),
        userCompany: selectCompany(state),
        registration: selectCompanyRegistration(state)
    };
};

const CompanyCrew = connect(mapStateToProps, mapDispatchToProps)(_Crew);

export default CompanyCrew;
